import comp from "./CriteriaRating";
export default comp;
